if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{
				// Guardar la cantidad actual para restaurar si se cancela
				const qtyInput = item.querySelector('.qty');
				if (qtyInput) {
					item.dataset.currentQty = qtyInput.value;
				}

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();

						// Confirmación con SweetAlert2 antes de eliminar
						Swal.fire({
							title: '¿Estás seguro?',
							text: 'Este producto será eliminado del carrito',
							icon: 'warning',
							showCancelButton: true,
							confirmButtonColor: '#000000',
							cancelButtonColor: '#6b7280',
							confirmButtonText: 'Sí, eliminar',
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							if (result.isConfirmed) {
								this.updateCartQty(item, 0);
							}
						});
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						const newQty = parseInt(qty.value);

						console.log('Input changed to:', newQty); // Debug

						// Si la cantidad es 0, mostrar confirmación
						if (newQty === 0) {
							e.target.blur();
							console.log('Showing confirmation dialog'); // Debug

							// Verificar si Swal está disponible
							if (typeof Swal !== 'undefined') {
								Swal.fire({
									title: '¿Estás seguro?',
									text: 'Este producto será eliminado del carrito',
									icon: 'warning',
									showCancelButton: true,
									confirmButtonColor: '#000000',
									cancelButtonColor: '#6b7280',
									confirmButtonText: 'Sí, eliminar',
									cancelButtonText: 'Cancelar'
								}).then((result) => {
									if (result.isConfirmed) {
										this.updateCartQty(item, 0);
									} else {
										// Restaurar la cantidad original si se cancela
										qty.value = item.dataset.currentQty || 1;
									}
								});
							} else {
								// Fallback si Swal no está cargado
								if (confirm('¿Estás seguro? Este producto será eliminado del carrito')) {
									this.updateCartQty(item, 0);
								} else {
									qty.value = item.dataset.currentQty || 1;
								}
							}
						} else {
							e.target.blur();
							this.updateCartQty(item, newQty);
						}
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			const cartItem = this.closest('[data-js-cart-item]');
			const newQty = parseInt(this.querySelector('.qty').value);

			console.log('CartProductQuantity changeCartInput called, newQty:', newQty); // Debug

			// Si la cantidad es 0, mostrar confirmación
			if (newQty === 0) {
				console.log('Showing confirmation dialog for qty 0'); // Debug

				// Verificar si Swal está disponible
				if (typeof Swal !== 'undefined') {
					Swal.fire({
						title: '¿Estás seguro?',
						text: 'Este producto será eliminado del carrito',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#000000',
						cancelButtonColor: '#6b7280',
						confirmButtonText: 'Sí, eliminar',
						cancelButtonText: 'Cancelar'
					}).then((result) => {
						if (result.isConfirmed) {
							document.getElementById('AjaxCartForm').updateCartQty(cartItem, 0);
						} else {
							// Restaurar la cantidad original si se cancela
							this.querySelector('.qty').value = cartItem.dataset.currentQty || 1;
						}
					});
				} else {
					console.log('Swal not available, using fallback'); // Debug
					// Fallback si Swal no está cargado
					if (confirm('¿Estás seguro? Este producto será eliminado del carrito')) {
						document.getElementById('AjaxCartForm').updateCartQty(cartItem, 0);
					} else {
						this.querySelector('.qty').value = cartItem.dataset.currentQty || 1;
					}
				}
			} else {
				setTimeout(()=>{
					document.getElementById('AjaxCartForm').updateCartQty(cartItem, newQty);
				}, 50);
			}
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}